import { useEffect } from "react";
import { FaBullseye, FaEye, FaHandshake, FaBed, FaUsers, FaCalendarCheck, FaAward } from "react-icons/fa";
import PageHeader from "../components/PageHeader";
import SectionTitle from "../components/SectionTitle";
import Counter from "../components/Counter";
import CTASection from "../components/CTASection";
import "../styles/Pages.css";

const values = [
  { icon: FaBullseye, title: "Our Mission", text: "To offer every guest a peaceful, luxurious and memorable experience — blending warm Bihari hospitality with modern comfort." },
  { icon: FaEye, title: "Our Vision", text: "To be the most loved resort and event destination in Patna, known for impeccable service and beautiful spaces." },
  { icon: FaHandshake, title: "Our Promise", text: "Clean rooms, honest pricing, delicious food and a team that treats every celebration like their own." },
];

const stats = [
  { icon: FaBed, end: 11, suffix: "+", label: "Luxury Rooms" },
  { icon: FaCalendarCheck, end: 200, suffix: "+", label: "Events Hosted" },
  { icon: FaUsers, end: 10000, suffix: "+", label: "Happy Guests" },
  { icon: FaAward, end: 4, suffix: "+", label: "Years of Excellence" },
];

const About = () => {
  useEffect(() => { document.title = "About Us | USHA Resort, Patna"; }, []);

  return (
    <>
      <PageHeader
        title="About USHA Resort"
        subtitle="Home · About Us"
        image="/images/aboutus/Aboutus_Header.png"
      />

      {/* ---------- Our story ---------- */}
      <section>
        <div className="container story-grid">
          <div className="story-content">
            <SectionTitle tag="Our Story" title="A Legacy of Warm Hospitality" align="left" />
            <p>
              USHA Resort began with a simple dream — to give the people of Patna a serene escape
              without leaving the city. What started as a boutique guesthouse has today grown into
              one of Patna's most loved destinations for stays, weddings and celebrations.
            </p>
            <p>
              Surrounded by lush greenery and designed with attention to every detail, the resort
              combines the charm of nature with the comforts of a modern hotel. From intimate family
              weekends to grand celebrations of 1,000+ guests, every event at USHA Resort is handled
              with the same care and passion.
            </p>
          </div>
          <div className="story-media">
            <img src="/images/aboutus/About_us.png" alt="USHA Resort Patna" />
          </div>
        </div>
      </section>

      {/* ---------- Mission / Vision / Promise ---------- */}
      <section className="amenities-section">
        <div className="container">
          <SectionTitle tag="What Drives Us" title="Mission, Vision & Promise" />
          <div className="value-grid gap-top">
            {values.map(({ icon: Icon, title, text }) => (
              <div className="value-card" key={title}>
                <div className="value-icon"><Icon /></div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------- Stats ---------- */}
      <section className="stats">
        <div className="container stats-grid">
          {stats.map(({ icon: Icon, end, suffix, label }) => (
            <div className="stat-item" key={label}>
              <Icon />
              <h3><Counter end={end} suffix={suffix} /></h3>
              <p>{label}</p>
            </div>
          ))}
        </div>
      </section>

      <CTASection />
    </>
  );
};

export default About;